// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';
import { useTranslator } from '@gandi/translate';

import { InputTextField, TextAreaField } from 'gandi.react-form';

import Row from './Row';

type Props = {|
  topics: {|
    domain: Array<{| text: string, value: string |}>,
    hosting: Array<{| text: string, value: string |}>,
  |},
  category: string,
  topic?: string,
|};

function Message({
  topics,
  category,
  topic,
}: Props): React.Element<typeof Base> {
  const { __ } = useTranslator();
  const requiredMessage =
    (category === 'domain' &&
      (topic === 'cybersquatting' || topic === 'other')) ||
    (category === 'hosting' &&
      (topic === 'illegal' ||
        topic === 'breaching' ||
        topic === 'pirated' ||
        topic === 'other'));

  return (
    <Base backgroundColor="grey-lighter" padding="small" separatorBottom>
      {topic === 'breaching' && (
        <>
          <Base className="for-2-columns">
            <TextAreaField
              label={__('Recipient of the notification')}
              name="params.recipient"
              rows={2}
              disabled
            />
          </Base>

          <InputTextField
            type="url"
            name="params.url"
            label={__('URL of the illegal content')}
            required
          />
          <TextAreaField
            name="params.description"
            label={__('Description of what seems litigious')}
            required
          />
          <TextAreaField
            name="params.reasons"
            label={__('Reasons why the content must be withdrawn')}
            required
          />
          <Row fullRow>
            <TextAreaField
              name="params.copy"
              label={__(
                'Copy of the mail to the author/editor, informing them of the litigious information or activity, and requesting its cessation/removal/correction, or proof that the author/editor could not be reached.'
              )}
              required
            />
          </Row>
        </>
      )}

      {!!category &&
        (!!topic || !topics[category]) &&
        topic !== 'breaching' && (
          <Row fullRow>
            <TextAreaField
              label={__('Message')}
              name="message"
              placeholder={__(
                'Describe your problem and the context as precisely ' +
                  'as possible, and provide us any error message you ' +
                  'have encountered.'
              )}
              required={requiredMessage}
              rows={12}
            />
          </Row>
        )}
    </Base>
  );
}

export default Message;
